import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <AppSection />
        <ContactSection />
        <MediaSection />
        <TopicsSection />
        <IndexSection />
        <CarouselSection />
        <UpdatesSection />
        <FaqSection />
        <AboutSection />
        <RankingSection />
        <CardsSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}